import React from "react";
import styled from "styled-components";

const flexProps = {
  end: "flex-end",
  start: "flex-start",
  center: "center",
  between: "space-between",
  around: "space-around",
};
const getFlexProp = (prop?: string) => (flexProps as any)[String(prop)];

export const Flex = React.memo(styled.div<{
  type?: "sides" /* | 'container'*/;
  column?: boolean;
  align?: keyof typeof flexProps;
  justify?: keyof typeof flexProps;
  wrap?: boolean;
  order?: number;
  grow?: boolean;
  width?: string;
  height?: string;
  gap?: string;
}>`
  display: flex;

  ${({ width }) => `width: ${width};`}
  ${({ height }) => `height: ${height};`}

  ${({ gap }) => `gap:${gap};`}

  ${({ type }) => {
    if (type === "sides")
      return `
      justify-content: space-between;
      align-items: center;
      width: 100%;
    `;
  }}

  ${({ column }) =>
    column &&
    `
    flex-direction: column;
  `}

  ${({ wrap }) =>
    wrap &&
    `
    flex-wrap: wrap;
  `}

  ${({ grow }) =>
    grow &&
    `
    flex-grow: 1;
  `}

  justify-content: ${({ justify }) => getFlexProp(justify)};
  align-items: ${({ align }) => getFlexProp(align)};

  ${({ order }) =>
    order &&
    `
    order: ${order};
  `}
`);

export default Flex;
